import { graphql, readInlineData } from 'react-relay';

import { type sbBrowseContentModuleBreadcrumbsTone_browseContentModule$key } from './__generated__/sbBrowseContentModuleBreadcrumbsTone_browseContentModule.graphql.ts';

import styles from './BrowseContentModuleBreadcrumbsTone.module.css';

const browseContentModuleBreadcrumbsToneFragment = graphql`
    fragment sbBrowseContentModuleBreadcrumbsTone_browseContentModule on ContentModuleInterface
    @inline {
        ... on ContentModuleLanding {
            breadcrumbsColor
        }
        ... on ContentModuleStorytelling {
            breadcrumbsColor
        }
    }
`;

export function resolveBrowseContentModuleBreadcrumbsTone(
    browseContentModuleRef:
        | sbBrowseContentModuleBreadcrumbsTone_browseContentModule$key
        | null
        | undefined
): string {
    const browseContentModuleData = readInlineData(
        browseContentModuleBreadcrumbsToneFragment,
        browseContentModuleRef
    );

    if (browseContentModuleData?.breadcrumbsColor === 'DARK') {
        return styles.toneDark;
    }

    return styles.toneLight;
}
